import script from "./FaceCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceCollection.vue?vue&type=script&setup=true&lang=js"

import "./FaceCollection.vue?vue&type=style&index=0&id=4c2f510e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2f510e"]])

export default __exports__